import React, { useState } from "react";
import { Input } from "@/components/ui/input";

// Editable combobox: type freely OR pick from suggestions (Master Data).
export function Combobox({ value, onChange, options = [], placeholder, testid, disabled, onPick, className }) {
  const [open, setOpen] = useState(false);
  const q = (value || "").toLowerCase();
  const filtered = options.filter((o) => o && o.toLowerCase().includes(q)).slice(0, 8);
  const pick = (o) => { onChange(o); if (onPick) onPick(o); setOpen(false); };
  return (
    <div className={`relative ${className || ""}`}>
      <Input
        data-testid={testid}
        disabled={disabled}
        value={value || ""}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
      />
      {open && filtered.length > 0 && (
        <div
          className="absolute z-50 mt-1 w-full max-h-56 overflow-y-auto rounded-lg border border-border bg-popover shadow-lg"
          data-testid={testid ? `${testid}-list` : undefined}
        >
          {filtered.map((o) => (
            <button
              key={o}
              type="button"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => pick(o)}
              className="block w-full text-left px-3 py-2 text-sm hover:bg-accent"
              data-testid={testid ? `${testid}-opt-${o}` : undefined}
            >
              {o}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
